const STATISTICS = {
  COUNT: 'count',
  AVERAGE: 'avg',
  SUM: 'sum',
  MIN: 'min',
  MAX: 'max'
}

export default STATISTICS
